/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SchemaDefinition } from '../../asyncapi/v2/models/Aai20SchemaDefinition';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { RenameSchemaDefinitionCommand } from './RenameSchemaDefinitionCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';

/**
 * @author c.desc2@gmail.com
 * @extends RenameSchemaDefinitionCommand
 * @class
 */
export class RenameSchemaDefinitionCommand_Aai20 extends RenameSchemaDefinitionCommand {
    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super(oldName, newName);
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see RenameSchemaDefinitionCommand#_nameToReference(String)
     * @param {string} name
     * @return {string}
     */
    _nameToReference(name : string) : string {
        return "#/components/schemas/" + name;
    }

    /**
     * @see RenameSchemaDefinitionCommand#_renameSchemaDefinition(Document, String, String)
     * @param {Document} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    _renameSchemaDefinition(document : Document, fromName : string, toName : string) : boolean {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(aai20Document.components) || this.isNullOrUndefined(aai20Document.components.schemas)) {
            return false;
        }
        if(ModelUtils.isDefined(aai20Document.components.getSchemaDefinition(toName))) {
            return false;
        }
        let schemaDef : Aai20SchemaDefinition = <Aai20SchemaDefinition>aai20Document.components.removeSchemaDefinition(fromName);
        schemaDef.rename(toName);
        aai20Document.components.addSchemaDefinition(toName, schemaDef);
        return true;
    }
}
RenameSchemaDefinitionCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand_Aai20";
RenameSchemaDefinitionCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




